import Marquee from "react-fast-marquee";
import { useLanguage } from "@/i18n";

const MarqueeRibbon = () => {
  const { t } = useLanguage();
  const items = t("marquee");
  return (
    <div data-testid="editorial-marquee" className="bg-[#DDE5DA] border-y border-forest/10 py-6 overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-4xl text-forest/80 mx-12 whitespace-nowrap">{item}</span>
            <span className="text-clay text-2xl md:text-4xl mx-4">—</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeRibbon;
